var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 117,
    height: 138,
    viewBox: "0 0 117 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M104.924 91.6324C112.89 77.3699 111.005 60.6748 104.23 45.3623C116.053 54.124 119.566 80.8057 114.349 95.9783C109.68 109.535 96.5092 106.706 104.924 91.6324Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M22.5255 115.515C12.4767 108.853 5.39225 98.7088 1.9726 87.188C18.2831 89.6088 24.8773 99.963 22.5255 115.515Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.7705 29.3149C21.224 34.4425 13.9296 46.9258 11.4961 60.0392C9.44198 71.1401 2.36341 68.7659 0 70.1309C1.91407 54.445 14.2797 30.8258 33.7705 29.3149Z",
    fill: "#DFDFDF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6532 114.768C72.5949 122.398 68.1948 132.461 73.015 136.468C76.7265 139.554 80.4262 130.903 84.1201 124.556C88.3393 117.3 90.4984 118.845 99.3218 118.04C119.811 116.168 115.603 110.661 105.368 108.952C101.545 108.31 95.9664 107.482 93.3812 101.87C90.9303 96.5446 93.5446 91.5163 97.6295 85.7237C103.168 77.8721 104.749 73.3687 92.6284 80.2579C80.1461 87.3512 79.4692 89.1771 66.3683 82.3112C48.774 73.0945 54.1252 82.4687 62.1492 90.3496C68.5508 96.6321 72.7291 105.65 72.6532 114.768Z",
    fill: "#0D99B7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.2496 53.0335C29.0385 50.5018 38.1129 51.6802 39.4434 44.3418C44.4853 47.9876 41.8768 60.1852 30.5383 65.5985C21.4873 69.9269 14.3854 56.9127 23.2496 53.0335Z",
    fill: "#CC3399"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.4771 108.777C48.6749 91.7207 45.2902 79.9431 52.9582 61.9589C62.1434 40.4105 56.7397 43.7997 46.1072 57.5722C36.7061 69.7523 25.0699 70.7381 7.569 74.5414C-2.91172 76.8165 -2.80084 81.0806 11.3913 81.6815C27.6201 82.364 30.8763 93.4882 30.4037 107.453C30.2461 112.161 29.5108 116.897 27.9644 121.185C22.724 135.698 29.2599 134.432 34.4886 127.1C37.0912 123.448 39.4196 119.336 40.5868 114.617C42.956 105.027 45.5762 107.535 49.8012 113.911C64.4251 135.955 62.1493 121.179 56.4771 108.777Z",
    fill: "#CC3399"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.1086 81.0042C70.0566 77.6501 70.5993 70.3875 74.0131 67.2784C78.3607 63.3234 82.2121 63.7667 84.5931 66.1584C92.8913 74.4709 79.7904 88.3426 73.1086 81.0042Z",
    fill: "#0D99B7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.369 38.7242C80.9317 47.0076 59.13 43.3384 46.7294 33.2467C40.7771 28.4051 41.8917 28.2826 48.2641 26.7017C53.7671 25.3367 57.0175 24.2692 63.495 29.1576C67.3465 32.0626 71.2738 34.1976 74.8744 35.0784C83.4469 37.1726 89.9244 36.9917 95.8125 34.8276C107.099 30.6742 107.437 31.8001 95.369 38.7242Z",
    fill: "#90278E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.4445 17.001C79.6249 23.7093 86.8319 29.5777 94.5115 29.881C100.12 30.1027 103.644 28.6093 94.7333 31.8877C89.4345 33.836 83.5231 33.976 75.61 32.0452C72.6397 31.3218 69.3718 29.5952 66.1097 27.221C58.2083 21.481 65.5612 19.4685 71.28 14.6968C76.7538 10.1176 73.4976 10.7826 76.4445 17.001Z",
    fill: "#00ADEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.4358 2.62145C56.6799 5.22896 62.0603 6.26146 68.0068 6.6698C73.5389 7.04896 74.636 6.44813 70.3643 11.6165C68.3861 14.0082 65.9643 16.0323 63.2566 17.724C56.7441 21.7957 50.9843 13.6115 47.6639 6.47146C44.5243 -0.271892 44.2034 0.0197764 50.4358 2.62145Z",
    fill: "#BE1E2D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4561 18.5698C43.8762 16.0381 44.203 13.2148 44.3081 10.3156C44.4715 5.67224 43.7537 5.60808 46.2688 9.70309C47.6285 11.9139 49.2858 14.3231 50.7505 16.3006C53.219 19.6198 55.0747 21.8131 51.054 22.9331C49.7118 23.3065 48.358 23.639 46.9983 23.9248C40.4332 25.2956 42.4932 24.339 43.4561 18.5698Z",
    fill: "#F6921E"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/logo.40d8df1f411c6e091e4119c516ce3172.svg";